import CardsList from './CardsList';

export default CardsList;
